import React from 'react';
import { instanative, luxury, ishop } from '../images/images';

const Rule = ({ color }) => (
  <hr
    style={{
      borderColor: color,
    }}
  />
);

const Rightside = () => {
  return (
    <>
      <div className="w3-col m2">
        <div className="w3-card w3-round w3-white w3-center w3-padding-16 right">
          <div className="w3-container">
            <p className="title_right">Upcoming Projects:</p>
            <Rule color="#49a6e9" />
            <p className="desc">luxurynailsjolie</p>
            <img src={luxury} alt="luxury" style={{ width: '100%' }} />
          </div>
          <div className="w3-padding-16 m2">
            <Rule color="#49a6e9" />
          </div>
          <div className="w3-container">
            <p className="desc">I-Shop (E-commerce)</p>
            <img src={ishop} alt="natie" style={{ width: '100%' }} />
          </div>
        </div>
        <br />

        <div className="w3-card w3-round w3-white w3-center">
          <div className="w3-container right">
            <p className="title_right">New Added</p>
            <div className="w3-padding-16 m2">
              <Rule color="#49a6e9" />
            </div>
            <p className="desc">Instagram Clone With React Native</p>

            <a
              href="https://expo.dev/@i-create/instagram?serviceType=classNameic&distribution=expo-go"
              target="_blank"
              rel="noreferrer"
              title="Click here"
            >
              {' '}
              <img src={instanative} alt="Avatar" style={{ width: '100%' }} />
            </a>

            <div className="w3-padding-16 m2">
              <Rule color="#49a6e9" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Rightside;
